import React, { useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import opgLogo from "../../Assets/Images/OPG_logo.svg";

function SideNavLoad({ name, ...props }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button onClick={handleShow} className="me-2 sideMenuIcon">
        <i className="fas fa-bars"></i>
      </Button>
      <Offcanvas show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
          <a className="navbar-brand" href="/">
            <img
              className="brand"
              src={opgLogo}
              alt="OPG Securities Logo"
              title="OPG Securities"
              width="100px"
              style={{padding: "10px 20px"}}
            />
          </a>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="navLinksStyle">
            <li className="list">
              <a href="http://ipo.opgsecurities.com:7000/">IPO</a>
            </li>
            <li className="list">
              <a href="http://rms.opgsecurities.com:8888/WEBR">RMS</a>
            </li>
            <li className="list">
              <a href="/">About</a>
            </li>
            <li className="list">
              <a href="contact">Contact</a>
            </li>
            <li className="list">
              <a href="https://122.160.40.174:10443/">Backoffice</a>
            </li>
            <li className="list">
              <a href="download">Downloads</a>
            </li>
            {/* <li className="list">
              <a href="http://oats.opgsecurities.com:3000/#/app">OATS</a>
            </li> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default SideNavLoad;
